import {
  ONLINE,
  OFFLINE,
  SET_STATUS_MESSAGE,
  TOGGLE_PRESET_DIALOG,
  OPEN_LEARN_MODE,
  SELECT_PRESET,
  SELECT_BAR,
  SELECT_BUTTON,
  SELECT_FADER,
  SELECT_GAP_CAP,
  SELECT_ZONE,
  BAR_INFO_ACTIVE,
  SET_BAR_INFO,
  LEARN_MODE_RECORDING,
  SET_LEARN_STRIKE_TYPE,
  SET_LEARN_STRIKE_COUNT,
  LEARN_MODE_AUTO_RECORDING,
  LEARN_MODE_USE_SOUNDS,
  SELECT_ERROR_LEARN_BAR,
  REVERTABLE_PRESET,
  RESET_DEVICE_PRESETS_IN_STATE,
  DEVICE_PRESETS_LOADED,
  OPEN_PREFERENCES,
  OPEN_PRESET_RENAMER,
  CLOSE_PRESET_RENAMER,
  SET_TEMP_IMPORTED_PRESETS,
  SET_IMPORTED_PRESET_NAME,
  SET_IMPORTED_PRESET_NAMES,
  RESET_IMPORTED_NAMES,
  SET_AVAILABLE_EDITOR,
  SET_EDITOR_UPDATE_AVAILABLE,
  SET_AVAILABLE_FIRMWARE,
  SET_UPDATES_AVAILABLE,
  LEARN_MODE_COMPLETE,
  OPEN_UNSAVED_CHANGES,
  SENSITIVITY_PRESET,
} from "./actionTypes";

import { makeBarInfo, getPresetFromID } from '../utilities'

import {
  setCurrentPreset,
  changeLowNote,
  changeOctave,
  getCrosstalkThreshold,
  getGlobalThreshold,
  exportBarDataToJSON,
} from "./";

import { xylo } from '../components/LearnModeSounds'

export const networkStatus = () => {
  return (dispatch) => {
    dispatch(navigator.onLine ? {type: ONLINE} : {type: OFFLINE})
  }
}

export const setAvailableFirmware = (version) => ({ type: SET_AVAILABLE_FIRMWARE, version: version });
export const setAvailableEditor = (version) => ({ type: SET_AVAILABLE_EDITOR, version: version });
export const setUpdateableEditor = (updateable) => {
  return (dispatch) => {
    dispatch({ type: SET_EDITOR_UPDATE_AVAILABLE, updateable: updateable });
  };
};

export const setUpdatesAvailable = () => {
  return (dispatch, getState) => {
    setTimeout(() => {
      dispatch(setStatusMessage("firmware and editor updates available"));
    }, 1000);
    setTimeout(() => {
      dispatch(
        setStatusMessage(
          getState().device.connected ? "connected" : "disconnected"
        )
      );
    }, 15000);
    dispatch({ type: SET_UPDATES_AVAILABLE, available: true });
  };
};
export const setStatusMessage = (message) => ({ type: SET_STATUS_MESSAGE, message: message });

export const togglePresetDialog = () => ({ type: TOGGLE_PRESET_DIALOG });

export const selectPreset = (selectedPreset) => ({ type: SELECT_PRESET, selectedPreset: selectedPreset });

export const openLearnMode = () => {
  return (dispatch) => {
    dispatch(selectBar(-1))
    dispatch(setBarInfoActive(false))
    dispatch({ type: SET_BAR_INFO, info: '' })
    dispatch({ type: OPEN_LEARN_MODE })
  }
};

export const selectBar = (bar) => ({ type: SELECT_BAR, bar: bar });
export const selectGapCap = (cap) => ({ type: SELECT_GAP_CAP, cap: cap });

export const setBarInfo = (bar, lowNote, octave, gapCaps) => {
  return (dispatch) => {
    dispatch({
      type: SET_BAR_INFO,
      info: makeBarInfo(bar, lowNote, octave, gapCaps)
    })
    // bar info active
    dispatch(setBarInfoActive(true))
  }
};

export const setBarInfoActive = (active) => ({ type: BAR_INFO_ACTIVE, active: active });

export const selectButton = (index) => ({ type: SELECT_BUTTON, index: index });

export const setRevertablePreset = (length) => ({ type: REVERTABLE_PRESET, diffLength: length });
export const resetDevicePresetStore = () => ({ type: RESET_DEVICE_PRESETS_IN_STATE });

export const selectZone = (zone) => ({ type: SELECT_ZONE, zone: zone });

export const selectFader = (index) => ({ type: SELECT_FADER, index: index });

export const devicePresetsLoaded = (status) => ({ type: DEVICE_PRESETS_LOADED, status: status });

export const openPreferences = (open) => {
  return (dispatch) => {
    dispatch({ type: OPEN_PREFERENCES, open: open })
  }
};

export const openPresetRenamer = () => ({ type: OPEN_PRESET_RENAMER });
export const closePresetRenamer = () => ({ type: CLOSE_PRESET_RENAMER });
export const setTempImportedPresets = (presets, duplicates) => {
  return {
    type: SET_TEMP_IMPORTED_PRESETS,
    presets: presets,
    duplicates: duplicates
  }
}
export const setImportedName = (index, name) => {
  return {
    type: SET_IMPORTED_PRESET_NAME,
    index: index,
    name: name
  }
}
export const setImportedNames = (names, updated) => {
  return {
    type: SET_IMPORTED_PRESET_NAMES,
    updated: updated,
    names: names
  }
}
export const resetImportedNames = () => {
  return {type: RESET_IMPORTED_NAMES}
}

export const selectUI = (control, presets, buttonMode) => {
  const controlType = control.values[0],
        controlValue = control.values[1]

  return (dispatch) => {
    switch (controlType) {
      case 'button':
        dispatch(selectButton(controlValue))
        // load preset if in presetMode
        if(buttonMode[controlValue] === 1) {
          const preset = getPresetFromID(presets, 'device-'+controlValue)
          dispatch(setCurrentPreset(preset, 'device-'+controlValue))
        }
        break;
      case 'fader':
        dispatch(selectFader(controlValue))
        break;
      case 'octave':
        dispatch(changeOctave(controlValue ? 1 : -1))
        break;
      case 'lowNote':
        dispatch(changeLowNote(controlValue ? 1 : -1))
        break;
      default:
    }
  }
};

export const setLearnModeRecord = (recording) => {
  return (dispatch) => {
    dispatch({type: LEARN_MODE_RECORDING, recording: recording})
  }
}

export const setUseLearnModeSound = (useSounds) => {
  return ({
    type: LEARN_MODE_USE_SOUNDS,
    useSounds: useSounds
  })
}

export const setLearnModeStrikeType = (strikeType) => {
  return (dispatch) => {
    dispatch({ type: SET_LEARN_STRIKE_TYPE, strikeType: strikeType })
    dispatch({ type: SET_LEARN_STRIKE_COUNT, count: 0 })
  }
}

export const setAutoLearnMode = (autoMode) => {
  return (dispatch, getState) => {
    dispatch({ type: LEARN_MODE_AUTO_RECORDING, learnModeAuto: autoMode })
    if(autoMode) {
      // dispatch(selectLearnBar(0))
      document.querySelectorAll('text.bar-index-text').forEach((t,i) => t.classList['remove']('active'))
      document.querySelector('text.bar-index-text').classList.add('active')
    }
  }
}

export const setLearnStrikeCount = (reset = false) => {
  return (dispatch, getState) => {
    const isRecording = getState().editor.learnModeRecording,
      useSounds = getState().editor.learnModeUseSounds,
      strikeType = getState().editor.learnModeStrikeType;
    let strikeCount = getState().editor.learnModeStrikeCount;

    if (!isRecording) return;
    
    // console.log("learn: set strike count", strikeCount);

    // trigger sound
    // TODO: move this out
    if (useSounds && !reset) strikeCount < 4
      ? xylo(strikeType === "hard" ? 466.164 : 440)
      : xylo(strikeType === "hard" ? 932.328 : 880);

    dispatch({
      type: SET_LEARN_STRIKE_COUNT,
      count: reset ? 0 : strikeCount + 1,
    });
  }
}

export const setErrorLearnBar = (bar) => {
  return ({type: SELECT_ERROR_LEARN_BAR, bar: bar})
}

export const learnModeComplete = (complete=true) => {
  return (dispatch, getState) => {
    const useSounds = getState().editor.learnModeUseSounds;
    // trigger sound
    // TODO: move this out
    if (useSounds && complete) {
      [
        261.63, // c4
        369.99, // f#4
        277.18, // c#4
        392.0, // g4
        523.25, // c5
        1046.5, // c6
      ].forEach((freq, i) => {
        setTimeout(() => xylo(freq), i * 200);
      });
      // export to JSON
      dispatch(exportBarDataToJSON());
    }

    // dispatch
    dispatch({ type: LEARN_MODE_COMPLETE, complete: complete });
  };
}

export const setSensitivityPreset = (value) => {
  return { type: SENSITIVITY_PRESET, preset: value };
}


export const openUnsavedChangesModal = (open = true) => {
  return { type: OPEN_UNSAVED_CHANGES, open: open };
};
